import flatten from 'lodash/flatten';
import sortBy from 'lodash/sortBy';

/**
 * []->{}->[]
 * Returns the list of prices in proper sort order
 *
 * @returns []
 */
export default  (prices, priceTypes) => {
  const pricesFilteredByPriceType = Object.keys(priceTypes)
    .map(priceTypeId => prices.filter(price => price.priceType === priceTypeId));

  const flattenPrices = flatten(pricesFilteredByPriceType)
    .map(price =>
      Object.assign(price, {
        presentationRank: priceTypes[price.priceType].presentationRank
      })
    );

  return sortBy(flattenPrices, 'presentationRank');
};



// WEBPACK FOOTER //
// ./frontend/react/utils/sim/sortedprices.js